export default function Social() {
  const socialLinks = [
    {
      name: 'TikTok',
      icon: 'ri-tiktok-fill',
      url: 'https://tiktok.com/@mercedeswithjacob',
      color: 'hover:bg-pink-500',
      description: 'Follow for daily luxury car content'
    },
    {
      name: 'Instagram',
      icon: 'ri-instagram-fill',
      url: 'https://instagram.com/mercedeswithjacob',
      color: 'hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500',
      description: 'See the latest inventory and behind-the-scenes'
    },
    {
      name: 'Facebook',
      icon: 'ri-facebook-fill',
      url: 'https://facebook.com/jacob.kapolkaa',
      color: 'hover:bg-blue-600',
      description: 'Join our community of Mercedes enthusiasts'
    }
  ];

  return (
    <section id="social" className="py-24 bg-black">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Stay <span className="text-amber-400">Connected</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Follow me on social media for the latest inventory updates, exclusive deals, luxury car insights, and behind-the-scenes content
          </p>
        </div>

        {/* Featured TikTok Video */}
        <div className="mb-16">
          <div className="bg-zinc-900 rounded-lg p-8 max-w-md mx-auto">
            <h3 className="text-white text-2xl font-semibold mb-6 text-center">Featured Video</h3>
            <div className="aspect-[9/16] bg-zinc-800 rounded-lg overflow-hidden">
              <iframe
                src="https://www.tiktok.com/player/v1/7428956002055130399"
                width="100%"
                height="100%"
                allow="autoplay; encrypted-media"
                allowFullScreen
                style={{ border: 0 }}
                title="Jacob TikTok Walkaround"
              />
            </div>
          </div>
        </div>

        {/* Social Links Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {socialLinks.map(social => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`bg-zinc-900 p-6 rounded-lg text-center transition-all duration-300 hover:scale-105 hover:shadow-xl group cursor-pointer ${social.color}`}
            >
              <div className="w-16 h-16 bg-zinc-800 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-transparent transition-colors">
                <i className={`${social.icon} text-amber-400 text-3xl group-hover:text-white`}></i>
              </div>
              <h3 className="text-white font-semibold text-lg mb-2">{social.name}</h3>
              <p className="text-gray-400 text-sm group-hover:text-white transition-colors">{social.description}</p>
            </a>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="bg-gradient-to-r from-amber-400 to-amber-500 rounded-lg p-8 text-center">
          <h3 className="text-black text-2xl font-bold mb-4">Ready to Drive Your Dream Mercedes?</h3>
          <p className="text-black/80 mb-6 text-lg">Contact me directly for personalized assistance and exclusive offers</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a 
              href="tel:+18479573340" 
              className="px-8 py-3 bg-black text-white font-semibold rounded-lg hover:bg-zinc-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Now
            </a>
            <a 
              href="mailto:jacob@mercedeswithjacob.com" 
              className="px-8 py-3 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              Email Me
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-zinc-800 text-center">
          <p className="text-gray-500 text-sm">
            © 2024 Mercedes with Jacob. All rights reserved. | 
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:text-amber-500 ml-1 cursor-pointer">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}